import { render } from "./QuestionsBlock.vue?vue&type=template&id=da1c86be"
import script from "./QuestionsBlock.vue?vue&type=script&lang=js"
export * from "./QuestionsBlock.vue?vue&type=script&lang=js"

import "./QuestionsBlock.vue?vue&type=style&index=0&id=da1c86be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__